import Api from '../common/Api';
import { Backend, headers } from "../common/Config";
import Helpers from '../common/Helpers';

export default class Servicios {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/servicios/create`,
            form: Helpers.processFormData(form),
            headers: {}
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/servicios/update`,
            form: Helpers.processFormData(form),
            headers: {}
        });
        return Helpers.dataReturn(response);
    };

    static async getState(page = 0, state = 0, form, limit = 10) {
        const response = await Api.post({
            url: `${Backend}/servicios/state/${page}/${state}`,
            form: { ...form, limit },
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0) {
        const response = await Api.get({
            url: `${Backend}/servicios/list/${page}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getToFuec() {
        const response = await Api.get({
            url: `${Backend}/servicios/tofuec`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getFrecuentes() {
        const response = await Api.get({
            url: `${Backend}/servicios/frecuentes`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/servicios/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getType() {
        const response = await Api.get({
            url: `${Backend}/servicios/types`,
            headers
        })
        return Helpers.dataReturn(response)
    }

    static async getTwunelId(id) {
        const response = await Api.get({
            url: `${Backend}/servicios/twnel/${id}`,
            headers
        })

        return Helpers.dataReturn(response);
    }

    static async cancelService(data) {
        const response = await Api.post({
            url: `${Backend}/servicios/cancelar`,
            form: data,
            headers,
        })

        return Helpers.dataReturn(response);
    }

    static async assignAllPreAsigned(data) {
        const response = await Api.post({
            url: `${Backend}/servicios/asignar-todos`,
            form: data,
            headers
        })

        return Helpers.dataReturn(response);
    }

    static async assignService(id) {
        const response = await Api.post({
            url: `${Backend}/servicios/asignar`,
            form: { id },
            headers
        })

        return Helpers.dataReturn(response);
    }

    static async preAssignFromList({ id, vehiculo, conductor_id }) {
        const response = await Api.post({
            url: `${Backend}/servicios/pre-asignar`,
            form: { id, vehiculo, conductor_id },
            headers
        });
        return Helpers.dataReturn(response);
    }

}
